import { AnimatePresence } from 'motion/react';
import { memo, useContext } from 'react';

import classes from './P2PAdminPanel.module.css';
import { P2PContext } from './P2PContext';
import P2PPermittedUserDetails from './P2PPermittedUserDetails';
import P2PWaitingUserDetails from './P2PWaitingUserDetails';

interface IProps {}

const P2PUserDetails: React.FC<IProps> = () => {
    const context = useContext(P2PContext);
    const { activeCategory, activeUserItem } = context;

    return (
        <>
            {activeUserItem && (
                <div className={`${classes['details-container']}`}>
                    <AnimatePresence>
                        {activeUserItem?.id && activeCategory !== 'waiting' && (
                            <P2PPermittedUserDetails />
                        )}
                        {activeUserItem?.user_id &&
                            activeCategory === 'waiting' && (
                                <P2PWaitingUserDetails />
                            )}
                    </AnimatePresence>
                </div>
            )}
        </>
    );
};
export default memo(P2PUserDetails);
